export const LINKS = {
  FB: "https://www.facebook.com/Gopickers-AR-107480848157625/",
  IG: "https://instagram.com/gopickers.ar",
  PLAYSTORE: "https://play.google.com/store/apps/details?id=com.pickit.pickers",
  AFIP: "http://qr.afip.gob.ar/?qr=TqPrV9qG5y43HSIvufDEzw,,",
};
export const routes = {
  INDEX: "/",
  FAQ: "/:countryCode/faq",
  TERMS: "/:countryCode/terms",
};

export const OPERATE_SUB_TABS = ["Deliver", "PickUp"];

export const ROAD_SAFETY_SUB_TABS = [
  "Bicycles",
  "Motorcycles",
  "Cars",
  "GeneralInfo",
];

export const FAQS_PROPS = {
  AR: {
    country: "Argentina",
    zonesLink: "https://linktr.ee/zonadecoberturapickers",
    whatsAppLink: "https://api.whatsapp.com/send?phone=5491136384786&text=%C2%A1Hola!%20tengo%20una%20consulta",
  },
  CO: {
    country: "Colombia",
    zonesLink: "https://linktr.ee/zonadecoberturacolombia",
    whatsAppLink: "https://api.whatsapp.com/send?phone=5491136384786",
  },
  MX: {
    country: "México",
    zonesLink: "https://linktr.ee/zonadecoberturamexico",
    whatsAppLink: "https://api.whatsapp.com/send?phone=5215531450250",
  },
  CL: {
    country: "Chile",
    zonesLink: "https://linktr.ee/zonadecoberturachile",
    whatsAppLink: "https://api.whatsapp.com/send?phone=5491136384786&text=%C2%A1Hola!%20tengo%20una%20consulta",
  },
};

export const COUNTRIES = ["AR", "CO", "MX", "CL"] as const;

export type CountryCodeType = (typeof COUNTRIES)[number];

export const GTM_ID = "GTM-T5W7T2NJ";

